import { Item } from 'core-components/library/grid'

import { getArray } from './getArray'

export const checkTypeRecur = (item: any) => {
  if (item && item.type !== Item) {
    if (item.props && item.props.children) {
      const iterableChildren = getArray(item.props.children)
      for (const child of iterableChildren) {
        if (checkTypeRecur(child)) {
          return true
        }
      }
      return false
    }
    return true
  }
  return false
}
